import AWSAppSyncClient from 'aws-appsync'

const {
    REACT_APP_AWS_APPSYNC_PUBLIC_ID: awsAccessKeyId,
    REACT_APP_AWS_APPSYNC_PUBLIC_SECRET: awsSecretAccessKey,
    REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT: awsAppSyncGraphQLEndpoint,
    REACT_APP_AWS_REGION: awsRegion,
} = window.APP_CONFIG

export default new AWSAppSyncClient({
    url: awsAppSyncGraphQLEndpoint,
    region: awsRegion,
    auth: {
        type: 'AWS_IAM',
        credentials: new window.AWS.Credentials({
            accessKeyId: awsAccessKeyId,
            secretAccessKey: awsSecretAccessKey,
        }),
    },
    disableOffline: true,
}, {
    defaultOptions: {
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
        },
    },
})
